/**
 * useOrderRail - the rail's rows, memoised on what they are made of.
 *
 * A projection and nothing else: the tracker document and the roster are
 * the truth, `railRows` is the arithmetic, and this hook only spares the
 * rail a recompute on renders that changed neither. Kept apart from the
 * component so the shell can hand the rows to anything else that wants
 * the order (the turn card, follow-the-turn) without a second copy.
 */
import { useMemo } from 'react';
import { railRows } from '../engine/roster/orderRail';
import type { RailInput, RailRow } from '../engine/roster/orderRail';

export function useOrderRail(input: RailInput): RailRow[] {
  const { tabs, participants, trackerActive, actorId, targetId, liveries, skipDownedTurns, sittingOut } = input;
  const { hiddenIds } = input;
  return useMemo(
    () =>
      railRows({
        tabs,
        participants,
        trackerActive,
        actorId,
        targetId,
        liveries,
        skipDownedTurns,
        sittingOut,
        hiddenIds,
      }),
    [tabs, participants, trackerActive, actorId, targetId, liveries, skipDownedTurns, sittingOut, hiddenIds],
  );
}
